import { Game } from "entities/game/types";
import { ModuleData } from "entities/modules/types";
import { Dispatch, SetStateAction } from "react";

export type ModuleDetailsType = {
  allGames: Game[];
  moduleId: string | null;
  availableStudios: { id: number; name: string }[] | undefined;
  handleDrawerClose: () => void;
  selectedTab: ModuleDetailsTabs;
  setSelectedTab: Dispatch<SetStateAction<ModuleDetailsTabs>>;
  moduleData: ModuleData | null;
  isLoadingSelectedGamesList: boolean;
  isLoadingAvailableStudios: boolean;
  isFetchingSelectedGamesList: boolean;
  threeCardsLoadingQueries: Record<number, boolean>;
  oneCardsLoadingQueries: Record<number, boolean>;
  topPrivacyTipsBlockImageLoadingQuery: boolean;
};

export enum ModuleDetailsTabs {
  General = "General",
  Tags = "Tags",
  SelectedGames = "SelectedGames",
  StudioOrdering = "StudioOrdering",
  Studios = "Studios",
  Translations = "Translations",
}

export enum ManagedTranslations {
  ModuleName = "Module name",
  CardTitle = "Card title",
  CardDescription = "Card description",
  ModuleTitle = "Module title",
  ModuleDescription = "Module description",
  CTAForRegisteredUser = "CTA for registered user",
  CTAForUnauthenticatedUser = "CTA for unregistered user",
}
